import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { useNewStore, usePlayerContext } from '../../hooks';

function SeekBackground() {
  const player = usePlayerContext();
  const { width, seekBackground = {} } = useNewStore('ui', player);
  const { ongoingSeek } = useNewStore('playback', player);
  const [thumbnailStyle, setThumbnailStyle] = useState({});

  useEffect(() => {
    const scale = width / seekBackground.width;
    const translate = (0.5 - (1 / (2 * scale))) * 100;

    setThumbnailStyle({
      ...{
        zIndex: -1,
        display: ongoingSeek ? 'block' : 'none',
        position: 'absolute',
        backgroundColor: 'transparent',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        top: '50%',
        backgroundPosition: `-${seekBackground?.x || 0}px -${seekBackground?.y || 0}px`,
        transform: `scale(${scale}) translateX(${translate}%) translateY(${translate - 50}%)`,
        width: seekBackground.width,
        height: seekBackground.height
      },
      ...seekBackground?.url && { backgroundImage: `url("${seekBackground?.url}")` },
      // programDistance exists only for Epg, which returns single images, not spritesheets
      ...!seekBackground?.programDistance && { backgroundSize: 'initial', backgroundRepeat: 'initial' }
    });
  }, [seekBackground.x, seekBackground.y, seekBackground.url, seekBackground.width, ongoingSeek]);

  return (
    <div style={thumbnailStyle} />
  );
}

export default SeekBackground;
